// src/utils/auth.ts

import { getRoute } from 'src/routes';

export const getLoginUrl = (): string => {
  if (process.env.NODE_ENV === 'production') {
    const currentOrigin = window.location.origin;
    // Robust case-insensitive replacement
    const mssOrigin = currentOrigin.replace(/\.ess\./i, '.mss.');
    return `${mssOrigin}${getRoute('login')}`;
  } else {
    return process.env.REACT_APP_LOCAL_MSS_URL || '';
  }
};

export const redirectToLogin = (): void => {
  const loginUrl = getLoginUrl();

  if (loginUrl) {
    window.location.assign(loginUrl);
  }
};
